/*----------------------------------
- HOME: ASK AI
----------------------------------*/

/**
 * "Ask AI about Unique Domains" (`section.askai`) on the marketing `AskAi` part: one pill per assistant of the repo's
 * provider catalog, each opening Home's prompt. Same prompt context, accessible names, `ask_ai_menu_opened` event and
 * placement as the shipped `HomeAskAiSection`, which the pages not yet rebuilt keep.
 *
 * @docs docs/features/website-landing-experience
 */

/*----------------------------------
- DEPENDANCES
----------------------------------*/

import { useMemo } from 'preact/hooks';

import type { AskYourAIProps } from '@uniquedomains/components/ask-ai';
import type { GeoContext } from '@uniquedomains/components/geo/pageGeo';

import { HOME_ASK_AI_COPY } from '@/client/catalogs/landing/home/homeCopy';
import WebsiteAskAi from '@/client/pages/landing/components/ask-ai/WebsiteAskAi';
import { LANDING_WEBSITE_PAGE_ROUTES } from '@/common/catalogs/landing/publicPages';

/*----------------------------------
- TYPES
----------------------------------*/

type HomeAskAiProps = {
    /** Home's GEO context (`buildHomeGeoContext`), shared with the GEO block so the two describe one page. */
    geoContext: GeoContext;
};

/*----------------------------------
- CONSTANTS
----------------------------------*/

const SECTION_STYLE = 'margin-top: var(--ud-section-gap-sm)';

/*----------------------------------
- COMPONENT
----------------------------------*/

const HomeAskAi = ({ geoContext }: HomeAskAiProps) => {
    const context = useMemo<AskYourAIProps>(
        () => ({
            pageType: 'home',
            intent: 'evaluate_product',
            pageUrl: LANDING_WEBSITE_PAGE_ROUTES.home,
            pageTitle: HOME_ASK_AI_COPY.promptPageTitle,
            geoContext,
            cta: 'open_database',
        }),
        [geoContext],
    );

    return (
        <section class="wrap" style={SECTION_STYLE}>
            <WebsiteAskAi
                title={HOME_ASK_AI_COPY.title}
                context={context}
                providerTitle={HOME_ASK_AI_COPY.providerTitle}
            />
        </section>
    );
};

export default HomeAskAi;
